import { useMemo } from 'react';
import { useAppSelector } from 'redux/hooks';

const useBillingState = () => {
    const { activeSubscriptions, plans, fetching } = useAppSelector((state) => state.billing);

    const isLoading = useMemo(() => fetching, [fetching]);

    return { activeSubscriptions, plans, isLoading };
};

export default useBillingState;
